import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { common, FilterCollection } from 'plato-js-client';
import { Table, Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import moment from 'moment';
import Pagination from './Pagination';
import Filter from './Filter';

class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SupplierPaid: {},
      page: 1,
      limit: 10,
      error: false,
      loading: true,
      showFEFilters: false,
      extraFilters: {
        raw: {
          date: false,
          selectedFilter: false,
          selectedOperator: false
        },
        ready: false
      },
      dataStatus: {
        currentPage: 1,
        prevPage: 0,
        nextPage: 2,
        currentLimit: 10,
        totalPages: 1,
        totalItems: false
      }
    };
    this.onDismiss = this.onDismiss.bind(this);
  }

  toggleFilters = () => {
    this.setState({ showFEFilters: !this.state.showFEFilters });
  }

  keepFilters = (filter) => {
    this.setState({ extraFilters: filter });
  }

  resetFiltersAndData = () => {
    this.setState({
      extraFilters: {
        raw: {
          date: false,
          selectedFilter: false,
          selectedOperator: false
        },
        ready: false
      }
    }, () => {
      this.getWorkOrders('Supplier Paid', 'instanceinvoiceapproveddatetime_desc');
    });
  }

  onDismiss() {
    this.setState({ error: false });
  }

  componentDidMount = () => {
    // Get all workorders in the state "Supplier Paid"
    this.getWorkOrders('Supplier Paid', 'instanceinvoiceapproveddatetime_desc');
  }

  persistWOs = (status, workOrders, data, newPage) => {

    let totalPages = Math.ceil(Number(data.total) / this.state.dataStatus.currentLimit);

    let dataStatus = {
      prevPage: Number(newPage) - 1,
      nextPage: Number(newPage) + 1,
      currentPage: Number(newPage),
      currentLimit: this.state.dataStatus.currentLimit,
      totalPages: totalPages,
      totalItems: data.total
    };


    this.setState({ [status]: workOrders, loading: false, dataStatus: dataStatus })
  }

  getWorkOrders = (status, order, limit = 10, page = 1, customFilters) => {
    this.setState({ loading: true });
    let workOrders = new FilterCollection({
      path: 'workorder',
      object: common.WorkOrder,
    });
    workOrders.orderBy = order;
    workOrders.page = page;
    workOrders.limit = limit;

    let basicFilters = {
      supplierid: this.props.user.id,
      type: 'Instance',
      status: status
    };

    if (customFilters) {
      basicFilters = { ...basicFilters, ...customFilters };
    }

    workOrders.addFilters([basicFilters]);
    workOrders.fields = 'id:property:status:booking:invoiceapproveddatetime:documents:invoice:fulldescription:shortdescription'
    workOrders.fetch().then(
      (data) => this.persistWOs('SupplierPaid', workOrders, data, page),
      (error) => this.setState({ error: error, loading: false })
    );
  }

  render() {
    const woTypeAndOrder = ['Supplier Paid', 'instanceinvoiceapproveddatetime_desc'];
    let showFEFilters = false;
    let disp = null;

    const downIconStyle = {
      display: "inline-block",
      marginLeft: "0.255em",
      verticalAlign: "0.255em",
      borderTop: "0.3em solid",
      borderRight: "0.3em solid transparent",
      borderBottom: "0",
      borderLeft: "0.3em solid transparent"
    };

    if (this.state.loading) {
      disp = (<div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
        <Spinner style={{ width: '3rem', height: '3rem', margin: "20px auto" }} color='secondary' />
      </div>);
    } else if (this.state.SupplierPaid && this.state.SupplierPaid.total === 0) {
      disp = 'No paid invoices found';
    }

    if (this.state.extraFilters.raw.selectedOperator) {
      showFEFilters = true;
    } else if (this.state.showFEFilters) {
      showFEFilters = true;
    }

    return (
      <React.Fragment>
        {this.state.error &&
          <Alert color="danger" isOpen toggle={this.onDismiss}>
            {`Unable to fetch invoiced and paid jobs - ${this.state.error.entity ? this.state.error.entity.errorDescription : this.state.error.message}`}
          </Alert>
        }
        <h3 style={{marginTop: 8}}>Invoices</h3>

        <div style={{ display: 'flex' }} >
          <Button color="info" style={{ width: 200 }} onClick={this.toggleFilters}> Filter invoices <span style={downIconStyle}></span></Button>

          {this.state.extraFilters.raw && this.state.extraFilters.raw.selectedFilter &&
            <Button color="danger"
              style={{ margin: "20px 0 20px 20px", width: 200 }}
              onClick={() => {
                this.resetFiltersAndData()
              }} > Remove filters </Button>}

        </div>
        {showFEFilters && 
        <Filter 
          fType={'invoices'} 
          extraFilters={this.state.extraFilters} 
          keepFilters={this.keepFilters} 
          woTypeAndOrder={woTypeAndOrder} 
          fetchWithFilters={this.getWorkOrders} 
          properties={this.props.properties}
        />
        }

        {disp ?
          <span>{disp}</span>
          :
          <InvoiceList
            resetFiltersAndData={this.resetFiltersAndData}
            extraFilters={this.state.extraFilters}
            dataStatus={this.state.dataStatus}
            getWorkOrders={this.getWorkOrders}
            woTypeAndOrder={woTypeAndOrder}
            workOrders={this.state['SupplierPaid']}
            keepFilters={this.keepFilters}
          />
        }

      </React.Fragment>
    );
  }
}

class InvoiceList extends Component {

  render() {

    let rows = this.props.workOrders.map(workOrder => <InvoiceRow key={workOrder.id} workOrder={workOrder} />);

    if (!this.props.workOrders || !this.props.workOrders.total) {
      return '';
    }

    return (
      <React.Fragment>
        <Table responsive size="sm" style={{ marginTop: "12px" }}>
          <thead>
            <tr>
              <th>Job ID</th>
              <th>Invoice ID</th>
              <th>Booking ID</th>
              <th>Property</th>
              <th>Description</th>
              <th>Completed Date</th>
              <th></th>
            </tr>
          </thead>
          {rows}
        </Table>
        <div style={{ display: "flex", justifyContent: 'space-around' }}>
          <Pagination extraFilters={this.props.extraFilters} stateStatus={this.props.dataStatus} nextPage={this.props.getWorkOrders} typeAndOrder={this.props.woTypeAndOrder} />
        </div>
      </React.Fragment>
    );
  }
}

class InvoiceRow extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  toggleModal = () => {
    this.setState({ modal: !this.state.modal });
  }

  render() {
    let workOrder = this.props.workOrder;
    let inv = workOrder.documents.filter((doc => doc.document.tags.collection[0].documenttag.id === 9));
    let viewButton = inv.length > 0 ? <Link className='btn btn-primary' to={`/document/${inv[0].document.id}`}>Invoice</Link> : null;

    return (
      <tbody>
        <tr>
          <td className="align-middle">{workOrder.id}</td>
          <td className="align-middle">{workOrder.invoice.invoicenumber}</td>
          <td className="align-middle">{workOrder.booking.id}</td>
          <td className="align-middle">{workOrder.property ? workOrder.property.name : null}</td>
          <td className="align-middle">
            <div>{workOrder.fulldescription ? workOrder.fulldescription : workOrder.shortdescription}</div>
          </td>
          <td className="align-middle">{moment(workOrder.invoiceapproveddatetime).format('ddd Do MMM YYYY')}</td>
          <td className="align-middle">
            {/* {viewButton} */}
            <Button color="primary" onClick={this.toggleModal}>Invoice</Button>
          </td>
        </tr>
        {this.state.modal &&
        <DocumentModal documentId={inv[0].document.id} workOrder={workOrder} toggle={this.toggleModal} />
        }
      </tbody>
    );
  }
}

class DocumentModal extends Component {
  componentDidMount = () => {
    var document = new common.Document(this.props.documentId);
    document.get().then(() => {
      this.setState({ document: document });
      document.file.get().then(() => {
        this.setState({ document: document });
      }, error => this.setState({ error: error }));
    }, error => this.setState({ error: error }));
  }

  render() {
    return (
      <Modal isOpen toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle}>Invoice {this.props.workOrder.invoice.invoicenumber}</ModalHeader>
        <ModalBody>
          {this.state && this.state.error &&
          <React.Fragment>
            {this.state.error.toString()}
          </React.Fragment>
          }
          {!(this.state && this.state.document) &&
          <React.Fragment>Loading...</React.Fragment>
          }
          {this.state && this.state.document &&
          <React.Fragment>
            <h4>{ this.state.document.name }</h4>
            { this.state.document.file.url &&
              <React.Fragment>
                <p><a className='btn btn-secondary btn-sm' href={ this.state.document.file.url } download={ this.state.document.name }>Download invoice</a></p>
                {this.state.document.id && 
                  <embed src={ this.state.document.file.url } width={ '800px' } height={ '1200px' } type={ this.state.document.mimetype.name } />
                }
              </React.Fragment>
            }
          </React.Fragment>
          }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.toggle}>close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default Invoices;



// WEBPACK FOOTER //
// ./src/Invoices.js